import { createElement, memo, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import './index.scss';
import { PrizeStatus } from '../../../types/rewardRecords';
import { fenToYuan } from '../../../utils/price';
import { getPriceFontFamily, getPriceWrapper } from '../../../utils/style';
import { formatTimestamp } from '../../../utils/time';
import { string2PositiveInt } from '../../../utils/number';
const priceFontFamily = getPriceFontFamily();
function CouponItem(props) {
    const { rewardItem, onClickItem } = props;
    const buttonName = useMemo(() => {
        return rewardItem.prizeStatus === PrizeStatus.NOT_USED ? '去使用' : '已使用';
    }, [rewardItem]);
    const expireTimeText = useMemo(() => {
        return formatTimestamp(rewardItem.expireTime, '.');
    }, [rewardItem.expireTime]);
    const requireAmountText = useMemo(() => {
        return string2PositiveInt(rewardItem.requireAmount);
    }, [rewardItem.requireAmount]);
    return <View className="coupon-item__wrapper">
      <Image className="coupon-item__background-img" source={{
        uri: 'https://img.meituan.net/makerjiulv/a1b18f29a50a7c86481ae526161615d63931.png'
    }}/>
      <View className="coupon-item__left-wrapper">
        <View className="coupon-item__amount-wrapper">
          <Text className="coupon-item__amount-prefix" style={{
        fontFamily: priceFontFamily,
        ...getPriceWrapper('-10rpx')
    }}>
            ¥
          </Text>
          <Text className="coupon-item__amount-text" style={{
        fontFamily: priceFontFamily
    }}>
            {fenToYuan(rewardItem.amount)}
          </Text>
        </View>
        <Text className="coupon-item__require-text">满{requireAmountText}可用</Text>
      </View>
      <View className="coupon-item__middle-wrapper">
        <Text className="coupon-item__title-text">{rewardItem.prizeName}</Text>
        <Text className="coupon-item__desc-text">{expireTimeText}到期</Text>
      </View>
      <Button className="coupon-item__right-button" onPress={() => onClickItem(rewardItem)} disabled={rewardItem.prizeStatus !== PrizeStatus.NOT_USED}>
        <Text className="coupon-item__button-text">{buttonName}</Text>
      </Button>
    </View>;
}
export default memo(CouponItem);
